import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const configureFontAwesome = (): void => {
  library.add(
    faFacebook, faTwitter, faInstagram, faCheck
  );
};
